export default "__VITE_ASSET__CWvHDfEo__"